import React from "react";
import Routes from "./Routes";
import MobileEstimateFAB from "./components/MobileEstimateFAB";
import GoogleReviewsBadge from "./components/GoogleReviewsBadge";
import StickyCallTab from "./components/StickyCallTab";

function App() {
  return (
    <>
      <Routes />
      <MobileEstimateFAB />
      <GoogleReviewsBadge />
      <StickyCallTab />
    </>
  );
}

export default App;